export const CMI_CORE_CHILDREN = "cmi.core._children"; // READ ONLY
export const CMI_CORE_STUDENT_ID = "cmi.core.student_id"; // READ ONLY
export const CMI_CORE_STUDENT_NAME = "cmi.core.student_name"; // READ ONLY
export const CMI_CORE_LESSON_LOCATION = "cmi.core.lesson_location"; // READ & WRITE
export const CMI_CORE_CREDIT_READONLY = "cmi.core.credit"; // READ ONLY
export const CMI_CORE_LESSON_STATUS = "cmi.core.lesson_status";// READ & WRITE
export const CMI_CORE_ENTRY = "cmi.core.entry"; // READ ONLY
export const CMI_CORE_SCORE_CHILDREN = "cmi.core.score._children"; // READ ONLY
export const CMI_CORE_SCORE_RAW = "cmi.core.score.raw"; // READ & WRITE
export const CMI_CORE_SCORE_MAX = "cmi.core.score.max"; // READ & WRITE
export const CMI_CORE_SCORE_MIN = "cmi.core.score.min"; // READ & WRITE
export const CMI_CORE_TOTAL_TIME = "cmi.core.total_time"; // READ ONLY
export const CMI_CORE_LESSON_MODE = "cmi.core.lesson_mode"; // READ ONLY
export const CMI_CORE_EXIT = "cmi.core.exit"; // WRITE ONLY
export const CMI_CORE_SESSION_TIME =  "cmi.core.session_time"; // WRITE ONLY
export const CMI_SUSPEND_DATA = "cmi.suspend_data"; // READ & WRITE
export const CMI_LAUNCH_DATA = "cmi.launch_data"; //READ ONLY
export const CMI_COMMENTS = "cmi.comments";// READ & WRITE
export const CMI_COMMENTS_FROM_LMS = "cmi.comments_from_lms";//READ ONLY

export const CMI_CREDIT = "credit";
export const CMI_NO_CREDIT = "no-credit";
export const LESSON_STATUS_PASSED = "passed";
export const LESSON_STATUS_COMPLETED = "completed";
export const LESSON_STATUS_FAILED = "failed";
export const LESSON_STATUS_INCOMPLETE = "incomplete";
export const LESSON_STATUS_BROWSED = "browsed";
export const LESSON_STATUS_NOT_ATTEMPTED = "not attempted";
export const LESSON_MODE_BROWSE = "browse";
export const LESSON_MODE_NORMAL = "normal";
export const LESSON_MODE_REVIEW = "learnerActionReview";
export const EXIT_TIME_OUT = "time-out";
export const EXIT_SUSPEND = "suspend";
export const EXIT_LOGOUT = "logout";

export const SUSPEND_DATA_LIMIT = 4096;

//NOT MANDATORY
export const CMI_OBJECTIVES_CHILDREN = "cmi.objectives._children"; //READ ONLY
export const CMI_OBJECTIVES_COUNT = "cmi.objectives._count";//READ ONLY
export const CMI_OBJECTIVES_N_ID = "cmi.objectives.n.id"; //READ & WRITE
export const CMI_OBJECTIVES_N_SCORE_CHILDREN = "cmi.objectives.n.score._children"; //READ ONLY
export const CMI_OBJECTIVES_N_SCORE_RAW = "cmi.objectives.n.score.raw"; //READ & WRITE
export const CMI_OBJECTIVES_N_SCORE_MAX = "cmi.objectives.n.score.max";//READ ONLY
export const CMI_OBJECTIVES_N_SCORE_MIN = "cmi.objectives.n.score.min";//READ ONLY
export const CMI_OBJECTIVES_N_STATUS = "cmi.objectives.n.status";//READ ONLY
export const CMI_STUDENT_DATA_CHILDREN = "cmi.student_data._children";//READ ONLY
export const CMI_STUDENT_DATA_MASTERY_SCORE = "cmi.student_data.mastery_score";//READ ONLY
export const CMI_STUDENT_DATA_MAX_TIME_ALLOWED = "cmi.student_data.max_time_allowed";//READ ONLY
export const CMI_STUDENT_DATA_TIME_LIMIT_ACTION = "cmi.student_data.time_limit_action";//READ ONLY
export const CMI_STUDENT_PREFERENCE_CHILDREN = "cmi.student_preference._children";//READ ONLY
export const CMI_STUDENT_PREFERENCE_AUDIO = "cmi.student_preference.audio";//READ & WRITE
export const CMI_STUDENT_PREFERENCE_LANGUAGE = "cmi.student_preference.language";//READ & WRITE
export const CMI_STUDENT_PREFERENCE_SPEED = "cmi.student_preference.speed";//READ & WRITE
export const CMI_STUDENT_PREFERENCE_TEXT = "cmi.student_preference.text";//READ & WRITE
export const CMI_INTERACTIONS_CHILDREN = "cmi.interactions._children";//READ ONLY
export const CMI_INTERACTIONS_COUNT = "cmi.interactions._count";//READ ONLY
export const CMI_INTERACTIONS_N_ID = "cmi.interactions.n.id";//READ ONLY
export const CMI_INTERACTIONS_N_OBJECTIVES_COUNT = "cmi.interactions.n.objectives._count";//READ ONLY
export const CMI_INTERACTIONS_N_OBJECTIVES_ID = "cmi.interactions.n.objectives.id";//WRITE ONLY
export const CMI_INTERACTIONS_N_TIME = "cmi.interactions.n.time.";//WRITE ONLY
export const CMI_INTERACTIONS_N_TYPE = "cmi.interaction.n.type";//WRITE ONLY
export const CMI_INTERACTIONS_N_CORRECT_RESPONSES_COUNT = "cmi.interaction.n.correct_responses._count"; //READ ONLY
export const CMI_INTERACTIONS_N_CORRECT_RESPONSES_N_PATTERN = "cmi.interaction.correct_responses.n.pattern";//WRITE ONLY
export const CMI_INTERACTIONS_N_WEIGHTING = "cmi.interaction.n.weighting";//WRITE ONLY
export const CMI_INTERACTIONS_N_STUDENT_RESPONSE = "cmi.interaction.student_response";//WRITE ONLY
export const CMI_INTERACTIONS_N_RESULT = "cmi.interaction.n.result";//WRITE ONLY
export const CMI_INTERACTIONS_N_LATENCY = "cmi.interaction.n.latency";


export const INTERACTION_TYPE_TRUE_FALSE = "true-false";
export const INTERACTION_TYPE_CHOICE = "choice";
export const INTERACTION_TYPE_FILL_IN = "fill-in";
export const INTERACTION_TYPE_MATCHING = "matching";
export const INTERACTION_TYPE_PERFORMACE = "performance";
export const INTERACTION_TYPE_SEQUENCING = "sequencing";
export const INTERACTION_TYPE_LIKERT = "likert";
export const INTERACTION_TYPE_NUMERIC = "numeric";

export const CMI_CORE_SCORE_MAX_DEFAULT = 100;
export const CMI_CORE_SCORE_MIN_DEFAULT = 0;



/** WEBPACK FOOTER **
 ** ./src/constants/scormConstants.js
 **/